cancelPendingFetches